import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CreateTccActionButton } from "routes/tcc/components/create-tcc-action-buttons";
import useAxios from "utils/useAxios";
import { ListingModalRef } from "../../../../components/ButtonModal";
import SubmitConfirmationModal from "./submitConfirmationModal";
import RejectConfirmationModal from "./rejectConfirmationModal";
import { useMasterArtworkCollectionStore } from "../../../../context/MasterArtworkCollectionContext";
import ApproveConfirmationModal from "./approveConfirmationModal";
import Spinner from "../../../../components/Spinner";
import {
  IGenericRequest, submitCollectionEditRequest,
  submitCollectionRequest,
} from "../../helpers/genericRequestHelpers";
import { MasterArtworkSearchActions } from "../../../../states/meta-artwork/search";
import { MasterArtworkCollectionActions } from "../../../../states/meta-artwork/collections";

export const actionButtons = () => {};

type ArtworkActionButtonsGroupProps = {
  isReadOnlyRequest: boolean;
  isEditing: boolean;
  isSaveOrSubmitInProgress: boolean;
  username: string;
  hasApproverPermission: boolean;
  hasCreatorPermission: boolean;
  setIsSaveOrSubmitInProgress: (isLoading: boolean) => void;
};

const ArtworkCollectionActionButtonsGroup = ({
  isReadOnlyRequest,
  isEditing,
  isSaveOrSubmitInProgress,
  username,
  setIsSaveOrSubmitInProgress,
  hasApproverPermission,
  hasCreatorPermission,
}: ArtworkActionButtonsGroupProps) => {
  const navigate = useNavigate();
  const axios = useAxios();
  const modalRef = useRef<ListingModalRef>(null);


  const [previeousState, setPreviousState] = useState<any>({})

  const{code} = useParams();

  // @ts-ignore
  const actionButtons: { [key: string]: any } = {
    // save: {
    //   show:
    //     !code &&
    //     !isReadOnlyRequest &&
    //     !isEditing &&
    //     hasCreatorPermission &&
    //     (state.requestStatus === "CREATED" ||
    //       state.requestStatus !== "SUBMITTED"),
    //   disabled: isSaveOrSubmitInProgress || !state.isValid,
    //   buttonStyleClass: "btn-primary",
    //   description: "Save",
    //   className: "ms-auto",
    //   clickHandler: () => {
    //     const data: IGenericRequest = {
    //       requestId: state.requestId,
    //       action: "CREATED",
    //       action_user: username,
    //       context: 2,
    //       country: 21,
    //       data: JSON.stringify(state),
    //       reason: null,
    //       comment: state.submitComment,
    //     };
    //     submitCollectionRequest(
    //       axios,
    //       data,
    //       username,
    //       dispatch,
    //       setIsSaveOrSubmitInProgress,
    //       navigate,
    //       "/artwork-master/collections/create",
    //       true,
    //     );
    //   },
    //   isButtonModal: false,
    // },
    submit: {
      show: true,
        // (state.requestStatus === "CREATED" ||
        //   state.requestStatus !== "SUBMITTED") &&
        // !hasApproverPermission &&
        // hasCreatorPermission &&
        // !isReadOnlyRequest,
      disabled: isSaveOrSubmitInProgress, //|| !state.isValid,
      buttonStyleClass: "btn-primary",
      description: "Submit for Approval",
      className: "ms-auto",
      clickHandler: () => {},
      isButtonModal: true,
      modalTitle: "Confirm Collection Request submission",
      // modal: (
      //   // <SubmitConfirmationModal
      //   //   onConfirm={() => console.log("submitting")}
      //   //   // onConfirm={() => {
      //   //   //   const data: IGenericRequest = {
      //   //   //     requestId: state.requestId,
      //   //   //     action: "SUBMITTED",
      //   //   //     action_user: username,
      //   //   //     context: 2,
      //   //   //     country: 21,
      //   //   //     data: JSON.stringify(state),
      //   //   //     reason: null,
      //   //   //     comment: state.submitComment,
      //   //   //   };
      //   //   //   submitCollectionRequest(
      //   //   //     axios,
      //   //   //     data,
      //   //   //     username,
      //   //   //     dispatch,
      //   //   //     setIsSaveOrSubmitInProgress,
      //   //   //     navigate,
      //   //   //     "/artwork-master/collections/create",
      //   //   //     true,
      //   //   //   );
      //   //   //   modalRef.current?.closeModal();
      //   //   // }}
      //   //   parentModalRef={modalRef}
      //   // />
      // ),
      modalRef: modalRef,
    },
    // approve: {
    //   show:
    //     !code &&
    //     ((!isReadOnlyRequest &&
    //       //@ts-ignore
    //       state.requestStatus === "SUBMITTED" &&
    //       !isEditing &&
    //       hasApproverPermission) ||
    //       (!isReadOnlyRequest && hasApproverPermission)),
    //   disabled: isSaveOrSubmitInProgress || !state.isValid,
    //   buttonStyleClass: "btn-primary",
    //   description: "Approve",
    //   className: "ms-auto",
    //   clickHandler: () => {},
    //   isButtonModal: true,
    //   modalTitle: "Approve",
    //   modal: (
    //     <ApproveConfirmationModal
    //       onConfirm={() => {
    //         const data: IGenericRequest = {
    //           requestId: state.requestId,
    //           action: "APPROVED",
    //           action_user: username,
    //           context: 2,
    //           country: 21,
    //           data: JSON.stringify(state),
    //           reason: null,
    //           comment: state.approveComment,
    //         };
    //
    //         submitCollectionRequest(
    //           axios,
    //           data,
    //           username,
    //           dispatch,
    //           setIsSaveOrSubmitInProgress,
    //           navigate,
    //           "/artwork-master/",
    //           true,
    //         );
    //
    //         modalRef.current?.closeModal();
    //       }}
    //       parentModalRef={modalRef}
    //     />
    //   ),
    //   modalRef: modalRef,
    // },
    // reject: {
    //   show:
    //     !code &&
    //     ((!isReadOnlyRequest &&
    //       state.requestStatus === "SUBMITTED" &&
    //       hasApproverPermission) ||
    //       (!isReadOnlyRequest && hasApproverPermission)),
    //   disabled: isSaveOrSubmitInProgress || !state.isValid,
    //   buttonStyleClass: "btn-danger",
    //   description: "Reject",
    //   className: "ms-auto",
    //   clickHandler: () => {},
    //   isButtonModal: true,
    //   modalTitle: "Confirm Collection Request Rejection",
    //   modal: (
    //     <RejectConfirmationModal
    //       onConfirm={() => {
    //         const data: IGenericRequest = {
    //           requestId: state.requestId,
    //           action: "REJECTED",
    //           action_user: username,
    //           context: 2,
    //           country: 21,
    //           data: JSON.stringify(state),
    //           reason: !!state.rejectReason?.id ? state.rejectReason?.id : null,
    //           comment: state.rejectComment,
    //         };
    //
    //         submitCollectionRequest(
    //           axios,
    //           data,
    //           username,
    //           dispatch,
    //           setIsSaveOrSubmitInProgress,
    //           navigate,
    //           "/artwork-master/",
    //           true,
    //         );
    //
    //         modalRef.current?.closeModal();
    //       }}
    //       parentModalRef={modalRef}
    //     />
    //   ),
    //   modalRef: modalRef,
    // },
    //
    // edit: {
    //   show:
    //     !!code &&
    //     state.requestStatus === "APPROVED" &&
    //     hasApproverPermission &&
    //     !isEditing &&
    //     state.isReadOnly,
    //   disabled: isSaveOrSubmitInProgress,
    //   buttonStyleClass: "btn-primary",
    //   description: "Edit",
    //   className: "ms-auto",
    //   clickHandler: () => {
    //     setPreviousState({ ...state });
    //     dispatch(MasterArtworkCollectionActions.setIsReadOnly(false));
    //   },
    //   modalTitle: "Approve",
    //   isButtonModal: false,
    // },
    // cancel: {
    //   show:
    //     state.requestStatus === "APPROVED" &&
    //     hasApproverPermission &&
    //     !state.isReadOnly,
    //   disabled: isSaveOrSubmitInProgress,
    //   buttonStyleClass: "btn-secondary",
    //   description: "Cancel",
    //   className: "ms-auto",
    //   clickHandler: () => {
    //     dispatch(MasterArtworkCollectionActions.setIsReadOnly(true));
    //     if(!!previeousState.id){
    //       dispatch(
    //         MasterArtworkCollectionActions.setCollection({ ...previeousState }),
    //       );
    //     }
    //     navigate("/artwork-master/search")
    //   },
    //   modalTitle: "Approve",
    //   isButtonModal: false,
    // },
    // approveEdit: {
    //   show:
    //     !!code &&
    //     ((!isReadOnlyRequest &&
    //       state.requestStatus === "APPROVED" &&
    //       isEditing &&
    //       hasApproverPermission) ||
    //       (!isReadOnlyRequest && hasApproverPermission)),
    //   disabled: isSaveOrSubmitInProgress || !state.isValid,
    //   buttonStyleClass: "btn-primary",
    //   description: "Approve edit",
    //   className: "ms-auto",
    //   clickHandler: () => {},
    //   isButtonModal: true,
    //   modalTitle: "Approve edit",
    //   modal: (
    //     <ApproveConfirmationModal
    //       onConfirm={() => {
    //         const data: IGenericRequest = {
    //           requestId: state.requestId,
    //           action: "EDITED",
    //           action_user: username,
    //           context: 2,
    //           country: 21,
    //           data: JSON.stringify(state),
    //           reason: null,
    //           comment: state.approveComment,
    //         };
    //
    //         submitCollectionRequest(
    //           axios,
    //           data,
    //           username,
    //           dispatch,
    //           setIsSaveOrSubmitInProgress,
    //           navigate,
    //           "/artwork-master/search",
    //           true,
    //         );
    //
    //         modalRef.current?.closeModal();
    //       }}
    //       parentModalRef={modalRef}
    //     />
    //   ),
    //   modalRef: modalRef,
    // },
    // delete: {
    //   show: !!code &&
    //     ((!isReadOnlyRequest &&
    //         state.requestStatus === "APPROVED" && isEditing &&
    //         hasApproverPermission) ||
    //       (!isReadOnlyRequest && hasApproverPermission)),
    //   disabled: isSaveOrSubmitInProgress || !state.isValid,
    //   buttonStyleClass: "btn-danger",
    //   description: "Delete",
    //   className: "ms-auto",
    //   clickHandler: () => {},
    //   isButtonModal: true,
    //   modalTitle: "Confirm Delete",
    //   modal: (
    //     <ApproveConfirmationModal
    //       onConfirm={() => {
    //         const data: IGenericRequest = {
    //           requestId: state.requestId,
    //           action: "DELETED",
    //           action_user: username,
    //           context: 2,
    //           country: 21,
    //           data: JSON.stringify(state),
    //           reason: null,
    //           comment: state.approveComment,
    //         };
    //
    //         // submitCollectionRequest(
    //         //   axios,
    //         //   data,
    //         //   username,
    //         //   dispatch,
    //         //   setIsSaveOrSubmitInProgress,
    //         //   navigate,
    ////                    "/artwork-master/search",
    //         //   true,
    //         // );
    //
    //         modalRef.current?.closeModal();
    //       }}
    //       parentModalRef={modalRef}
    //     />
    //   ),
    //   modalRef: modalRef,
    // },
  };

  return (
    <div className="d-flex justify-content-end mt-auto pt-3">
      <div className="d-flex gap-3 me-auto">
        <CreateTccActionButton {...actionButtons.save} />
        <CreateTccActionButton {...actionButtons.reject} />
        <CreateTccActionButton {...actionButtons.delete} />
      </div>

      <div className="d-flex gap-3" style={{ height: 38 }}>
        {isSaveOrSubmitInProgress && (
          <Spinner hideLabel={true} mediumSpinner={true} />
        )}

        <CreateTccActionButton {...actionButtons.submit} />

        <CreateTccActionButton {...actionButtons.approve} />

        <CreateTccActionButton {...actionButtons.continueReview} />

        <CreateTccActionButton {...actionButtons.reOpen} />
        <CreateTccActionButton {...actionButtons.approveEdit} />

        <CreateTccActionButton {...actionButtons.edit} />

        <CreateTccActionButton {...actionButtons.cancel} />
      </div>
    </div>
  );
};

export default ArtworkCollectionActionButtonsGroup;
